<template>
  <Layout>
    <PageHeader :title="$t('module.dashboard')" :items="items" />
    <DashboardContent />
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import DashboardContent from "@/components/dashboard/DashboardContent.vue";
import i18n from "@/i18n";

export default {
  name: "AdminDashboard",
  page: { title: i18n.t("module.dashboard") },
  components: { Layout, PageHeader, DashboardContent },
  data() {
    return { items: [{ text: i18n.t("module.dashboard"), active: true }] };
  },
};
</script>
